import { SvgIcon } from "@/svg";
import clsx from "clsx";

type CheckIconProps = {
  visible?: boolean;
  className?: string;
  active?: boolean;
};

export function CheckIcon({ visible = true, className = "", active = false }: CheckIconProps) {
  return (
    <span
      className={clsx(
        className,
        visible ? "text-sematicGreen" : "opacity-0",
        active && "text-dark opacity-100",
      )}
    >
      <SvgIcon icon="Check" />
    </span>
  );
}
